import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';

interface Props {
  showRisks: boolean;
  phoneNumber?: string;
  address?: string;
  city?: string;
  postcode?: string;
  country?: string;
  riskList?: string[];
}

function ContactAndAddress({ showRisks, phoneNumber, address, city, postcode, country, riskList = [] }: Props) {
  return (
    <>
      {phoneNumber && (
        <SummaryRow
          key="phone-number"
          label="Phone Number"
          value={phoneNumber}
          isRisk={showRisks && riskList.includes(Q.PHONE_NUMBER)}
        />
      )}
      {address && (
        <SummaryRow
          key="address"
          label="Permanent Residential Address"
          value={address}
          isRisk={showRisks && riskList.includes(Q.HOME_ADDRESS)}
        />
      )}
      {city && <SummaryRow key="city" label="City" value={city} isRisk={showRisks && riskList.includes(Q.CITY)} />}
      {postcode && (
        <SummaryRow
          key="postcode"
          label="Postcode"
          value={postcode}
          isRisk={showRisks && riskList.includes(Q.POSTCODE)}
        />
      )}
      {country && (
        <SummaryRow key="country" label="Country" value={country} isRisk={showRisks && riskList.includes(Q.COUNTRY)} />
      )}
    </>
  );
}

export default ContactAndAddress;
